import { render, staticRenderFns } from "./InputDateOfBirth.vue?vue&type=template&id=f55b3202&"
import script from "./InputDateOfBirth.vue?vue&type=script&lang=js&"
export * from "./InputDateOfBirth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports